export var Orientation;
(function (Orientation) {
    Orientation["vertical"] = "vertical";
    Orientation["horizontal"] = "horizontal";
})(Orientation || (Orientation = {}));
export var StepState;
(function (StepState) {
    StepState["active"] = "active";
    StepState["completed"] = "completed";
    StepState["pending"] = "pending";
})(StepState || (StepState = {}));
export var IconType;
(function (IconType) {
    IconType["default"] = "default";
    IconType["featuredIcon"] = "featuredIcon";
})(IconType || (IconType = {}));
export var StepSize;
(function (StepSize) {
    StepSize["sm"] = "sm";
    StepSize["md"] = "md";
})(StepSize || (StepSize = {}));
